module.exports = __webpack_public_path__ + "img/krottenkopf.1b1b8a15.jpg";